import { render, staticRenderFns } from "./TransactionCallOverReport.vue?vue&type=template&id=b920dd72&scoped=true&"
import script from "./TransactionCallOverReport.vue?vue&type=script&lang=js&"
export * from "./TransactionCallOverReport.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCallOverReport.vue?vue&type=style&index=0&id=b920dd72&lang=scss&scoped=true&"
import style1 from "./TransactionCallOverReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b920dd72",
  null
  
)

export default component.exports